

export const events = () => {

  const opponentsBtn = document.querySelector(".js-opponents-button");
  const opponentsFly = document.querySelector(".events__fly");
  const opponentsCount = document.querySelector(".opponents__count");
  const opponentsClear = document.querySelector(".js-opponents-clear");
  const opponentsClose = document.querySelector(".js-opponents-close");
  const opponentsFilter = document.querySelectorAll(".js-events-filter");
  
  //const opponentsCheckbox = document.querySelectorAll(".js-opponents-checkbox");

  var opponentsNumber = 0;


  document.querySelector(".opponents__box")?.addEventListener("click", function(e){

    if(e.target && e.target.classList.contains("js-opponents-checkbox")) {
      if ( e.target.checked ){
        opponentsNumber = +opponentsNumber + 1;
      } else {
        opponentsNumber = +opponentsNumber - 1;
      }

      if ( opponentsNumber == 0 ) {
        opponentsCount.innerHTML = "";
      }
      if ( opponentsNumber > 0 ) {
        opponentsCount.innerHTML = "Выбрана " + opponentsNumber + " команда";
      }
      if ( opponentsNumber > 1 ) {
        opponentsCount.innerHTML = "Выбрано " + opponentsNumber + " команды";
      }
      if ( opponentsNumber > 4 ) {
        opponentsCount.innerHTML = "Выбрано " + opponentsNumber + " команд";
      }
      
    }
  
  });



  opponentsClear?.addEventListener("click",function(){

    let opponentsCheckbox = document.querySelectorAll(".js-opponents-checkbox");
    for ( let checkbox of opponentsCheckbox ){
      checkbox.checked = false;
      opponentsNumber = 0;
      opponentsCount.innerHTML = "";
    }

  });


  if ( opponentsFilter ) {
    for ( let league of opponentsFilter ) {
      league.addEventListener('click',function(){
  
        if ( opponentsFly && opponentsBtn ) {
          opponentsFly.classList.remove("events__fly_open");
          opponentsBtn.classList.remove("events__opponents-btn_open");
        }

        let opponentsCheckbox = document.querySelectorAll(".js-opponents-checkbox");
        for ( let checkbox of opponentsCheckbox ){
          checkbox.checked = false;
          opponentsNumber = 0;
          opponentsCount.innerHTML = "";
        }
        
      });
    }
  }

  
  

  opponentsBtn?.addEventListener("click", function(){

    opponentsFly.classList.toggle("events__fly_open");
    opponentsBtn.classList.toggle("events__opponents-btn_open");

  });

  opponentsClose?.addEventListener('click', function() {
    opponentsFly.classList.remove("events__fly_open");
    opponentsBtn.classList.remove("events__opponents-btn_open");
  });

  document.addEventListener('keydown', function(e) {
    if ( document.querySelector(".events__opponents-btn_open") ){
      let keyCode = e.keyCode;
      if (keyCode === 27) {
        opponentsFly.classList.remove("events__fly_open");
        opponentsBtn.classList.remove("events__opponents-btn_open");
      }
    }
  });


  

  
  

  

  


}